import { msg } from '@lingui/core/macro';

export const SHARED_CARD_PILL_LABELS_OVERDUE = msg`Overdue`;
export const SHARED_CARD_PILL_LABELS_DUE_SOON = msg`Due soon`;
export const SHARED_CARD_PILL_LABELS_REFRESHER = msg`Refresher`;
export const SHARED_CARD_PILL_LABELS_UPDATED = msg`Updated`;
